
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("alkG3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $35afa4b433410e0b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $35afa4b433410e0b$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': "F\xfcgen Sie Ihr eigenes Emoji hinzu",
    'fabric.emoji.add.label': "Emoji hinzuf\xfcgen",
    'fabric.emoji.cancel.label': 'Abbrechen',
    'fabric.emoji.categories.label': "Emoji-Kategorie ausw\xe4hlen",
    'fabric.emoji.categories.search.results': 'Suchergebnisse',
    'fabric.emoji.category.activity': "Aktivit\xe4t",
    'fabric.emoji.category.all.uploads': 'Alle Uploads',
    'fabric.emoji.category.flags': 'Flaggen',
    'fabric.emoji.category.foods': 'Essen und Trinken',
    'fabric.emoji.category.frequent': "H\xe4ufig",
    'fabric.emoji.category.nature': 'Natur',
    'fabric.emoji.category.objects': 'Objekte',
    'fabric.emoji.category.people': 'Personen',
    'fabric.emoji.category.places': 'Reisen und Orte',
    'fabric.emoji.category.productivity': "Produktivit\xe4t",
    'fabric.emoji.category.symbols': 'Symbole',
    'fabric.emoji.category.user.uploads': 'Ihre Uploads',
    'fabric.emoji.choose.file.screenReaderDescription': "W\xe4hlen Sie eine Datei f\xfcr das Emoji. JPG, PNG oder GIF. Max. Gr\xf6\xdfe: 1\xa0MB.",
    'fabric.emoji.choose.file.title': "Datei ausw\xe4hlen",
    'fabric.emoji.delete.description': 'Alle existierenden Instanzen dieses Emojis werden durch {emojiShortName} ersetzt',
    'fabric.emoji.delete.label': 'Entfernen',
    'fabric.emoji.delete.screenreader.tooltip': "Wenn Sie das {shortName}-Emoji l\xf6schen m\xf6chten, dr\xfccken Sie die R\xfccktaste.",
    'fabric.emoji.delete.title': 'Emoji entfernen',
    'fabric.emoji.delete.tooltip': "L\xf6schen",
    'fabric.emoji.emojipicker.emoi.roledescription': "Emoji-Schaltfl\xe4che",
    'fabric.emoji.emojipicker.error': 'Fehler',
    'fabric.emoji.error.delete.failed': 'Entfernen fehlgeschlagen',
    'fabric.emoji.error.image.too.big': "Das ausgew\xe4hlte Bild hat mehr als 1 MB",
    'fabric.emoji.error.invalid.image': "Das ausgew\xe4hlte Bild ist ung\xfcltig.",
    'fabric.emoji.error.upload.failed': 'Upload fehlgeschlagen',
    'fabric.emoji.error.upload.timeout': "Zeitlimit bei Upload \xfcberschritten",
    'fabric.emoji.image.requirements': "JPG, PNG oder GIF. Max. Gr\xf6\xdfe 1 MB.",
    'fabric.emoji.name.ariaLabel': "Geben Sie einen Namen f\xfcr das neue Emoji ein.",
    'fabric.emoji.picker': 'Emoji-Auswahl',
    'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {Suchergebnisse} other {Emojis}}',
    'fabric.emoji.pickerlist.tabpanel': 'Panel mit Emojis, Aktionen und Liste',
    'fabric.emoji.placeholder': "z.\xa0B. Guten Tag",
    'fabric.emoji.preview': 'Ihr neues Emoji {emoji} sieht toll aus',
    'fabric.emoji.preview.title': 'Vorschau',
    'fabric.emoji.retry.label': 'Wiederholen',
    'fabric.emoji.search.label': 'Name des Emojis',
    'fabric.emoji.search.placeholder': 'Suchen',
    'fabric.emoji.search.status': 'Alle Emojis werden angezeigt',
    'fabric.emoji.select.skin.list.ariaLabel': 'Auswahl der Hautfarbe',
    'fabric.emoji.select.skin.tone.ariaLabel': "W\xe4hlen Sie eine Hautfarbe aus\xa0\u2013 {selectedTone} ausgew\xe4hlt"
};

});


//# sourceMappingURL=de.532ac0ce.js.map
